import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getRouteByName } from 'Helpers/Routes';

import Head from 'Components/helpers/Head';

import { setError } from 'Redux/actions/global';

@connect(
    (state) => ({}), {
    setError
}
)
export default class Terms extends React.Component {
    static propTypes = {
        setError: PropTypes.func.isRequired,
        params: PropTypes.shape({
            version: PropTypes.string
        }).isRequired
    };
    static defaultProps = {};

    defaultVersion = 'march-2020';
    versions = {
        'march-2020': {
            date: 'march 2020',
            version: '5.0',
            component: require('./versions/march2020').default
        },
        'march-2017': {
            date: 'march 2017',
            version: '4.0',
            component: require('./versions/march2017').default
        },
        'july-2016': {
            date: 'july 2016',
            version: '3.0',
            component: require('./versions/july2016').default
        },
        'november-2014': {
            date: 'november 2017',
            version: '2.0',
            component: require('./versions/november2014').default
        }
    };

    constructor(props) {
        super(props);

        this.state = {
            currentVersion: this.getVersion(props)
        };
    }

    componentWillReceiveProps = nextProps => {
        if (this.props.params.version !== nextProps.params.version) {
            this.setState({
                ...this.state,
                currentVersion: this.getVersion(nextProps)
            });
        }
    }

    getVersion = props => {
        let currentVersion;
        if (props.params && props.params.version) {
            if (this.versions.hasOwnProperty(props.params.version)) {
                currentVersion = this.versions[props.params.version];
            } else {
                props.setError({ errorType: 'notFound' });
                currentVersion = null;
            }
        } else {
            currentVersion = this.versions[this.defaultVersion];
        }

        return currentVersion;
    }

    render() {
        const { currentVersion } = this.state;

        if (!currentVersion) {
            return (null);
        }

        let Component = currentVersion.component;
        return (
            <div className="container-terms">
                <Head
                    title={`General terms of use and trade terms`}
                    description={`General terms of use and trade terms. Version ${currentVersion.version}, ${currentVersion.date}`}
                    robots={`index, follow`}
                    canonical={getRouteByName('terms').path}
                />
                <div className="container-fluid">
                    <Component />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Terms/index.js